// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import iView from 'iview'
import 'iview/dist/styles/iview.css'

Vue.use(iView)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.newCron = function (params) {
  const {element, callback} = params
  const app = new Vue({
    el: `#${element}`,
    components: { App },
    template: '<App/>'
  })
  app.callback = callback
}



// WEBPACK FOOTER //
// ./src/main.js